import { defineSlotRecipe } from '@chakra-ui/react';

export const draggablePanelSlotRecipe = defineSlotRecipe({
  className: 'draggable-panel',
  slots: ['root', 'header', 'title', 'body', 'footer'],
  base: {
    root: {
      border: '2px solid',
      borderColor: 'neutral.black',
      backgroundColor: 'neutral.black',
      position: 'absolute',
      width: 'fit-content',
      zIndex: 2,
      display: 'flex',
      gap: 0.25,
      flexDirection: 'column',
    },
    header: {
      userSelect: 'none',
      paddingY: 0,
      backgroundColor: 'neutral.800',
      height: { base: '40px', '4k': '48px' },
    },
    title: {
      paddingLeft: 2,
      textTransform: 'uppercase',
      height: '100%',
      textStyle: 'screenStd',
      color: 'neutral.200',
    },
    body: {
      display: 'flex',
      gap: 0.25,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'neutral.850',
      paddingInline: 0,
    },
    footer: {
      display: 'flex',
      position: 'sticky',
      bottom: 0,
      padding: 2,
      backgroundColor: 'neutral.850',
    },
  },
});
